import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  textColor?: string;
}

export const Root = styled.div`
  margin: 23px 0px 23px 0px;
  position: relative;
`

export const TopContainer = styled.div`
  display: flex;
  padding: 10px 0px 5px 0px;
  font-family: Roboto;
  height: 14px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #204078;
`

export const InputContainer = styled.div`
  position: relative;
`

export const TextContainer = styled.input`
  display: flex;
  align-items: center;
  height: 48px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  width: calc(100% - 62px);
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : C.LIGHT_GRAY};
  padding: 0px 46px 0px 16px;
`

export const TipLabel = styled.div`
  position: absolute;
  bottom: -20px;
  height: 14px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : '#8891a0'};
`

export const RemoveIconContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  right: 0px;
  top: 0px;
  margin: 6px;
  padding: 8px;
  cursor: pointer;
`

export const HelpTextContainer = styled.div`
  margin: 42px 0px 0px 0px;
`

export const HelpText = styled.div`
  margin: 19px 0px 0px 0px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #c9c9c9;
`

export const ChipsContainer = styled.div`
  margin: 30px 0px 0px 0px;
  display: flex;
  flex-wrap: wrap;
`